import { SortDirection } from "../../../CoStar/Api/AnalyticReports/Common/index.js";
/** CoStar.Api.Reports2.SortDirection */
export { SortDirection };
/** CoStar.Api.Reports2.ReportThemeNames */
export var ReportThemeNames;
(function (ReportThemeNames) {
    ReportThemeNames[ReportThemeNames["Default"] = 0] = "Default";
    ReportThemeNames[ReportThemeNames["Apartments"] = 1] = "Apartments";
})(ReportThemeNames || (ReportThemeNames = {}));
/** CoStar.Api.Reports2.GeographyEntityIdType */
export var GeographyEntityIdType;
(function (GeographyEntityIdType) {
    GeographyEntityIdType[GeographyEntityIdType["SubmarketId"] = 0] = "SubmarketId";
    GeographyEntityIdType[GeographyEntityIdType["ClusterId"] = 1] = "ClusterId";
    GeographyEntityIdType[GeographyEntityIdType["CoreBasedStatisticalAreaId"] = 2] = "CoreBasedStatisticalAreaId";
    GeographyEntityIdType[GeographyEntityIdType["ResearchMarketId"] = 3] = "ResearchMarketId";
    GeographyEntityIdType[GeographyEntityIdType["NationalId"] = 4] = "NationalId";
    GeographyEntityIdType[GeographyEntityIdType["CountyId"] = 5] = "CountyId";
    GeographyEntityIdType[GeographyEntityIdType["CityId"] = 6] = "CityId";
    GeographyEntityIdType[GeographyEntityIdType["NationalMajorId"] = 7] = "NationalMajorId";
    GeographyEntityIdType[GeographyEntityIdType["RegionId"] = 8] = "RegionId";
    GeographyEntityIdType[GeographyEntityIdType["StateId"] = 9] = "StateId";
    GeographyEntityIdType[GeographyEntityIdType["PostalCodeId"] = 10] = "PostalCodeId";
    GeographyEntityIdType[GeographyEntityIdType["UKPostalCodeDistrictId"] = 12] = "UKPostalCodeDistrictId";
    GeographyEntityIdType[GeographyEntityIdType["UKCountyId"] = 13] = "UKCountyId";
    GeographyEntityIdType[GeographyEntityIdType["USPostalCodeId"] = 16] = "USPostalCodeId";
    GeographyEntityIdType[GeographyEntityIdType["ForwardSortationId"] = 18] = "ForwardSortationId";
    GeographyEntityIdType[GeographyEntityIdType["CollegeId"] = 20] = "CollegeId";
    GeographyEntityIdType[GeographyEntityIdType["USBlockGroupId"] = 21] = "USBlockGroupId";
    GeographyEntityIdType[GeographyEntityIdType["UKOutputAreaId"] = 22] = "UKOutputAreaId";
    GeographyEntityIdType[GeographyEntityIdType["CADisseminationAreaId"] = 23] = "CADisseminationAreaId";
    GeographyEntityIdType[GeographyEntityIdType["USCensusId"] = 24] = "USCensusId";
    GeographyEntityIdType[GeographyEntityIdType["SchoolAttendanceZoneId"] = 25] = "SchoolAttendanceZoneId";
    GeographyEntityIdType[GeographyEntityIdType["SchoolDistrictId"] = 26] = "SchoolDistrictId";
    GeographyEntityIdType[GeographyEntityIdType["CollegeNationalId"] = 27] = "CollegeNationalId";
    GeographyEntityIdType[GeographyEntityIdType["CurrentTrueOwnerId"] = 28] = "CurrentTrueOwnerId";
    GeographyEntityIdType[GeographyEntityIdType["HistoricalTrueOwnerId"] = 29] = "HistoricalTrueOwnerId";
    GeographyEntityIdType[GeographyEntityIdType["CoStarProductMarketId"] = 31] = "CoStarProductMarketId";
    GeographyEntityIdType[GeographyEntityIdType["CoStarProductCountryMajorMarketsId"] = 37] = "CoStarProductCountryMajorMarketsId";
    GeographyEntityIdType[GeographyEntityIdType["ContinentMajorId"] = 38] = "ContinentMajorId";
    GeographyEntityIdType[GeographyEntityIdType["SubcontinentId"] = 39] = "SubcontinentId";
    GeographyEntityIdType[GeographyEntityIdType["CoStarProductCountryId"] = 44] = "CoStarProductCountryId";
    GeographyEntityIdType[GeographyEntityIdType["CoStarCollegeCountryId"] = 47] = "CoStarCollegeCountryId";
})(GeographyEntityIdType || (GeographyEntityIdType = {}));
/** CoStar.Api.Reports2.EntityType */
export var EntityType;
(function (EntityType) {
    EntityType[EntityType["Unknown"] = 0] = "Unknown";
    EntityType[EntityType["Property"] = 1] = "Property";
    EntityType[EntityType["LeaseDeal"] = 2] = "LeaseDeal";
    EntityType[EntityType["SaleComp"] = 3] = "SaleComp";
    EntityType[EntityType["SaleCompEntity"] = 4] = "SaleCompEntity";
    EntityType[EntityType["ForSale"] = 5] = "ForSale";
    EntityType[EntityType["LeaseAnalysis"] = 6] = "LeaseAnalysis";
    EntityType[EntityType["Tenant"] = 7] = "Tenant";
    EntityType[EntityType["ShoppingCenter"] = 8] = "ShoppingCenter";
    EntityType[EntityType["ApartmentListing"] = 9] = "ApartmentListing";
})(EntityType || (EntityType = {}));
/** CoStar.Api.Reports2.ReportStage */
export var ReportStage;
(function (ReportStage) {
    ReportStage[ReportStage["Unknown"] = 0] = "Unknown";
    ReportStage[ReportStage["Started"] = 1] = "Started";
    ReportStage[ReportStage["DataPreparation"] = 2] = "DataPreparation";
    ReportStage[ReportStage["ReportGeneration"] = 3] = "ReportGeneration";
    ReportStage[ReportStage["Export"] = 4] = "Export";
    ReportStage[ReportStage["Done"] = 5] = "Done";
    ReportStage[ReportStage["Failed"] = 6] = "Failed";
    ReportStage[ReportStage["Queued"] = 7] = "Queued";
})(ReportStage || (ReportStage = {}));
